export const getLastItem = <T>(array: T[] | undefined | null): T | null => {
  return array && array.length > 0 ? array[array.length - 1] : null;
};
